import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as ManagePin from './managePin';

export default combineReducers({
  managePin: ManagePin.default,
});

export const sagas = [call(ManagePin.saga)];
